import { render, staticRenderFns } from "./QuotesListView.vue?vue&type=template&id=0b84a3f4"
import script from "./QuotesListView.vue?vue&type=script&lang=ts"
export * from "./QuotesListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports